<template>
  <div class="thumb-anim-container">
    <div class="thumb-anim-circle thumb-anim-circle1" />
    <div class="thumb-anim-circle thumb-anim-circle2" />
    <div class="thumb-anim-circle thumb-anim-circle3" />
    <div class="thumb-anim-circle thumb-anim-circle4" />
    <div class="thumb-anim-circle thumb-anim-circle5" />
    <svg
      class="thumb-anim-thumb"
      width="100pt"
      height="100pt"
      version="1.1"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="m20.277 41.727h-16.266c-1.5195 0-2.7109 1.1914-2.7109 2.7109v43.371c0 1.5195 1.1914 2.7109 2.7109 2.7109h16.266c1.5195 0 2.7109-1.1914 2.7109-2.7109l-0.003906-43.371c0.003906-1.5195-1.1875-2.7109-2.707-2.7109z" />
        <path
          d="m98.699 46.863c0-4.418-3.0312-8.8867-8.8242-8.8867h-26.262c3.75-6.7109 4.8555-16.148 2.2461-23.055-1.9141-5.0781-5.5781-8.043-10.312-8.3438l-0.078125-0.007813c-3.082-0.1875-5.75 2.1211-6.0078 5.1992-0.67578 6.8516-3.6758 18.965-7.9766 23.266-3.6211 3.6211-6.7227 5.1406-11.859 7.6523-0.74219 0.36328-1.5547 0.76172-2.4141 1.1875 0.015624 0.1875 0.023437 0.37109 0.023437 0.5625v42.93c0.62109 0.21094 1.2344 0.42187 1.8359 0.62891 8.4805 2.9219 15.812 5.4453 27.016 5.4453h21.23c5.793 0 8.8242-4.4727 8.8242-8.8867 0-1.3125-0.26562-2.625-0.79297-3.8281 1.9297-0.34766 3.6172-1.2734 4.8711-2.6953 1.4219-1.6133 2.2031-3.7578 2.2031-6.0391 0-1.3047-0.26562-2.6211-0.78906-3.8203 4.6523-0.80469 7.0742-4.7969 7.0742-8.7422 0-2.2891-0.81641-4.5938-2.4062-6.2812 1.582-1.6914 2.3984-3.9961 2.3984-6.2852z" />
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'Thumb',
  };
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;

  .thumb-anim-container {
    min-width: 2.8rem;
    min-height: 2.8rem;
    width: 2.8rem;
    height: 2.8rem;
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    svg {
      fill: var(--success);

      transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
      width: 1.7rem;
      height: 1.7rem;
      min-width: 1.7rem;
      min-height: 1.7rem;
      transform: scale(0);
    }

    @mixin circle {
      transition: all 0.5s cubic-bezier(0.2, 1, 0.2, 1);
      position: absolute;

      background: var(--success);

      width: 10%;
      height: 10%;
      border-radius: 1000px;
    }

    @keyframes thumb {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    .thumb-anim-thumb {
      animation-name: thumb, fade;
      animation-delay: 0.25s, 2s;
      animation-duration: 1s, 1s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1), cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }

    @keyframes circle1 {
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(0, 500%);
      }
    }

    @keyframes circle2 {
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(470%, 150%);
      }
    }

    @keyframes circle3 {
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(-470%, 150%);
      }
    }

    @keyframes circle4 {
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(-330%, -450%);
      }
    }

    @keyframes circle5 {
      from {
        transform: translate(0, 0);
      }
      to {
        transform: translate(330%, -450%);
      }
    }

    .thumb-anim-circle1 {
      @include circle;
      animation-name: circle1, fade;
      animation-delay: 0s, 0.5s;
      animation-duration: 1s, 1s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1), cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }

    .thumb-anim-circle2 {
      @include circle;
      animation-name: circle2, fade;
      animation-delay: 0s, 0.5s;
      animation-duration: 1s, 1s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1), cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }

    .thumb-anim-circle3 {
      @include circle;
      animation-name: circle3, fade;
      animation-delay: 0s, 0.5s;
      animation-duration: 1s, 1s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1), cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }

    .thumb-anim-circle4 {
      @include circle;
      animation-name: circle4, fade;
      animation-delay: 0s, 0.5s;
      animation-duration: 1s, 1s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1), cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }

    .thumb-anim-circle5 {
      @include circle;
      animation-name: circle5, fade;
      animation-delay: 0s, 0.5s;
      animation-duration: 1s, 1s;
      animation-timing-function: cubic-bezier(0.2, 1, 0.2, 1), cubic-bezier(0.2, 1, 0.2, 1);
      animation-fill-mode: forwards;
    }

    @keyframes fade {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  }
</style>
